<div class="signature-flow-container">
    <!-- Header -->
    <div class="flow-header">
        <div class="header-info">
            <h2>
                <mat-icon>account_tree</mat-icon>
                FLUX SEMNĂTURI - DOCUMENT GENERAT
            </h2>
            <div class="document-info">
                <div class="info-row">
                    <mat-icon>description</mat-icon>
                    <span class="label">Template:</span>
                    <span class="value">{{ flowData?.template_name }}</span>
                </div>
                <div class="info-row" *ngIf="flowData?.template_directie_name || flowData?.template_compartiment_name">
                    <mat-icon>business</mat-icon>
                    <span class="label">Organizație:</span>
                    <span class="value">
                        {{ flowData?.template_directie_name }}
                        <span *ngIf="flowData?.template_directie_name && flowData?.template_compartiment_name"> / </span>
                        {{ flowData?.template_compartiment_name }}
                    </span>
                </div>
                <div class="info-row" *ngIf="flowData?.reg_number">
                    <mat-icon>confirmation_number</mat-icon>
                    <span class="label">Nr. Registru:</span>
                    <span class="value">{{ flowData?.reg_number }} / {{ flowData?.reg_date | date:'dd.MM.yyyy' }}</span>
                </div>
                <div class="info-row">
                    <mat-icon>tag</mat-icon>
                    <span class="label">ID Document:</span>
                    <span class="value">#{{ flowData?.document_generat_id }}</span>
                    <span class="mx-2">|</span>
                    <span class="label">ID Registratură:</span>
                    <span class="value">#{{ flowData?.document_registratura_id }}</span>
                </div>
                <div class="info-row" *ngIf="flowData?.operator_name">
                    <mat-icon>person</mat-icon>
                    <span class="label">Întocmit de:</span>
                    <span class="value">{{ flowData?.operator_name }}</span>
                </div>
                <div class="info-row" *ngIf="flowData?.current_user_name">
                    <mat-icon>print</mat-icon>
                    <span class="label">Vizualizat de:</span>
                    <span class="value">{{ flowData?.current_user_name }}</span>
                </div>
            </div>
        </div>
        <div class="header-actions">
            <button mat-raised-button color="primary" class="export-btn" (click)="exportToPdf()" [disabled]="isExporting || !hasCompletSignatures">
                <mat-icon *ngIf="!isExporting">picture_as_pdf</mat-icon>
                <mat-spinner *ngIf="isExporting" diameter="20"></mat-spinner>
                <span>{{ isExporting ? 'Export...' : 'Export PDF' }}</span>
            </button>
            <button mat-icon-button class="close-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Badges Row -->
    <div class="badges-row" *ngIf="flowData">
        <span class="badge badge-doc-id">
            <mat-icon>article</mat-icon>
            ID: {{ flowData.document_generat_id }}
        </span>
        <span class="badge badge-exemplar">
            <mat-icon>content_copy</mat-icon>
            {{ flowData.is_dual ? '2 Exemplare (Dual)' : '1 Exemplar' }}
        </span>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Se încarcă fluxul de semnături...</p>
    </div>

    <!-- Error State -->
    <div class="error-state" *ngIf="errorMessage && !isLoading">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h3>{{ errorMessage }}</h3>
        <button mat-raised-button color="primary" (click)="loadFlowData()">
            <mat-icon>refresh</mat-icon>
            Reîncearcă
        </button>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && !errorMessage && !hasCompletSignatures">
        <mat-icon class="empty-icon">assignment_late</mat-icon>
        <h3>Nu există semnături configurate</h3>
        <p>Acest document nu are semnături configurate pentru fluxul de aprobare.</p>
    </div>

    <!-- Flow Diagram -->
    <div class="flow-diagrams-wrapper" *ngIf="!isLoading && !errorMessage && hasCompletSignatures">

        <!-- Exemplar Complet -->
        <div class="flow-column" [ngClass]="{'single-column': !flowData?.is_dual}">
            <div class="column-header complet">
                <mat-icon>people</mat-icon>
                <span>EXEMPLAR COMPLET</span>
                <small>(Toți semnatarii)</small>
            </div>

            <div class="flow-content">
                <!-- Start Node -->
                <div class="flow-node start-node">
                    <div class="node-icon"><mat-icon>person_add</mat-icon></div>
                    <div class="node-content">
                        <span class="node-title">ÎNTOCMITOR</span>
                        <span class="node-subtitle">Operator care generează documentul</span>
                    </div>
                </div>

                <div class="flow-connector">
                    <div class="connector-line"></div>
                    <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                </div>

                <!-- Signature Nodes -->
                <ng-container *ngFor="let node of flowData?.exemplar_complet; let i = index; let last = last">
                    <div class="flow-node signature-node" [ngClass]="[getSignTypeClass(node.sign_type), getStatusClass(node.type)]">
                        <div class="node-order">{{ i + 1 }}</div>
                        <div class="node-content">
                            <div class="node-header">
                                <mat-icon>{{ getSignTypeIcon(node.sign_type) }}</mat-icon>
                                <span class="functie-name">{{ node.functie_name }}</span>
                            </div>
                            <div class="node-badges">
                                <span class="type-badge" [ngClass]="getSignTypeClass(node.sign_type)">
                                    {{ getSignTypeLabel(node.sign_type) }}
                                </span>
                                <span class="status-badge" [ngClass]="getStatusClass(node.type)">
                                    <mat-icon>{{ getStatusIcon(node.type) }}</mat-icon>
                                    {{ getStatusLabel(node.type) }}
                                </span>
                            </div>
                            <div class="node-details" *ngIf="node.directie_name || node.compartiment_name || node.user_name || node.action_date">
                                <div *ngIf="node.directie_name" class="detail-row">
                                    <mat-icon>business</mat-icon>
                                    <span>{{ node.directie_name }}</span>
                                </div>
                                <div *ngIf="node.compartiment_name" class="detail-row">
                                    <mat-icon>folder</mat-icon>
                                    <span>{{ node.compartiment_name }}</span>
                                </div>
                                <div *ngIf="node.user_name" class="detail-row user-assigned">
                                    <mat-icon>person</mat-icon>
                                    <span>{{ node.user_name }}</span>
                                    <span class="user-badge">Operator</span>
                                </div>
                                <div *ngIf="node.action_date" class="detail-row action-date">
                                    <mat-icon>event</mat-icon>
                                    <span>{{ formatDate(node.action_date) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flow-connector" *ngIf="!last">
                        <div class="connector-line"></div>
                        <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                    </div>
                </ng-container>

                <!-- End Node -->
                <div class="flow-connector">
                    <div class="connector-line"></div>
                    <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                </div>

                <div class="flow-node end-node">
                    <div class="node-icon"><mat-icon>verified_user</mat-icon></div>
                    <div class="node-content">
                        <span class="node-title">ÎNREGISTRARE FINALĂ</span>
                        <span class="node-subtitle">Documentul revine la întocmitor pentru înregistrare și sigiliu instituție</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Exemplar Cetățean -->
        <div class="flow-column cetatean-column" *ngIf="flowData?.is_dual">
            <div class="column-header cetatean">
                <mat-icon>person</mat-icon>
                <span>EXEMPLAR CETĂȚEAN</span>
                <small>(Copie solicitant)</small>
            </div>

            <div class="flow-content">
                <!-- Start Node -->
                <div class="flow-node start-node">
                    <div class="node-icon"><mat-icon>person_add</mat-icon></div>
                    <div class="node-content">
                        <span class="node-title">ÎNTOCMITOR</span>
                        <span class="node-subtitle">Operator care generează documentul</span>
                    </div>
                </div>

                <ng-container *ngIf="hasCetateanSignatures">
                    <div class="flow-connector">
                        <div class="connector-line"></div>
                        <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                    </div>

                    <!-- Signature Nodes -->
                    <ng-container *ngFor="let node of flowData?.exemplar_cetatean; let i = index; let last = last">
                        <div class="flow-node signature-node" [ngClass]="[getSignTypeClass(node.sign_type), getStatusClass(node.type)]">
                            <div class="node-order">{{ i + 1 }}</div>
                            <div class="node-content">
                                <div class="node-header">
                                    <mat-icon>{{ getSignTypeIcon(node.sign_type) }}</mat-icon>
                                    <span class="functie-name">{{ node.functie_name }}</span>
                                </div>
                                <div class="node-badges">
                                    <span class="type-badge" [ngClass]="getSignTypeClass(node.sign_type)">
                                        {{ getSignTypeLabel(node.sign_type) }}
                                    </span>
                                    <span class="status-badge" [ngClass]="getStatusClass(node.type)">
                                        <mat-icon>{{ getStatusIcon(node.type) }}</mat-icon>
                                        {{ getStatusLabel(node.type) }}
                                    </span>
                                </div>
                                <div class="node-details" *ngIf="node.directie_name || node.compartiment_name || node.user_name || node.action_date">
                                    <div *ngIf="node.directie_name" class="detail-row">
                                        <mat-icon>business</mat-icon>
                                        <span>{{ node.directie_name }}</span>
                                    </div>
                                    <div *ngIf="node.compartiment_name" class="detail-row">
                                        <mat-icon>folder</mat-icon>
                                        <span>{{ node.compartiment_name }}</span>
                                    </div>
                                    <div *ngIf="node.user_name" class="detail-row user-assigned">
                                        <mat-icon>person</mat-icon>
                                        <span>{{ node.user_name }}</span>
                                        <span class="user-badge">Operator</span>
                                    </div>
                                    <div *ngIf="node.action_date" class="detail-row action-date">
                                        <mat-icon>event</mat-icon>
                                        <span>{{ formatDate(node.action_date) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-connector" *ngIf="!last">
                            <div class="connector-line"></div>
                            <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                        </div>
                    </ng-container>

                    <div class="flow-connector">
                        <div class="connector-line"></div>
                        <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                    </div>

                    <div class="flow-node end-node">
                        <div class="node-icon"><mat-icon>verified_user</mat-icon></div>
                        <div class="node-content">
                            <span class="node-title">ÎNREGISTRARE FINALĂ</span>
                            <span class="node-subtitle">Document pentru cetățean cu sigiliu instituție</span>
                        </div>
                    </div>
                </ng-container>

                <div class="empty-cetatean" *ngIf="!hasCetateanSignatures">
                    <mat-icon>info</mat-icon>
                    <span>Nu sunt configurate semnături pentru exemplarul cetățean</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Legend -->
    <div class="flow-legend" *ngIf="!isLoading && !errorMessage && hasCompletSignatures">
        <span class="legend-title">Legendă tipuri:</span>
        <div class="legend-item sign-type-semnare">
            <mat-icon>edit</mat-icon> Semnare
        </div>
        <div class="legend-item sign-type-aprobare">
            <mat-icon>check_circle</mat-icon> Aprobare
        </div>
        <div class="legend-item sign-type-confirmare">
            <mat-icon>verified</mat-icon> Confirmare
        </div>
        <div class="legend-item sign-type-olografica">
            <mat-icon>draw</mat-icon> Semnare Olografică
        </div>
        <span class="legend-separator">|</span>
        <span class="legend-title">Status:</span>
        <div class="legend-item status-pending">
            <mat-icon>schedule</mat-icon> În așteptare
        </div>
        <div class="legend-item status-signed">
            <mat-icon>check_circle</mat-icon> Semnat
        </div>
        <div class="legend-item status-rejected">
            <mat-icon>cancel</mat-icon> Respins
        </div>
    </div>
</div>
